/* main-cart — pagina /cart. theme.js (DL.bindDrawer) leagă deja click-urile pe [data-dl-line-qty]
   oriunde apar, drawer sau pagină, deci +/-/șterge funcționează din prima. Ce NU face theme.js
   pentru pagină: după `dl:cart-updated`, el re-randează DOAR sertarul (și doar dacă e deschis) —
   pe pagina /cart trebuie re-randată SECȚIUNEA însăși, prin Section Rendering API, folosind
   data-section-id-ul real al secțiunii (NU un nume hardcodat: pe temă, id-ul secțiunii dintr-un
   șablon JSON e cel atribuit de Shopify la randare, nu neapărat "main-cart").

   ATENȚIE la URL-ul cerut (bug prins la review): Section Rendering API randează DOAR secțiunile
   care fac parte din pagina CERUTĂ. `/?sections=<id>` cere pagina de start, care nu conține
   secțiunea `main` a șablonului de coș — răspunsul n-are cheia, `html` e undefined și re-randarea
   nu se întâmpla niciodată (butoanele +/− păreau moarte, rândul șters rămânea pe ecran, fiindcă
   `data-dl-line-qty` e randat static în snippets/cart-lines.liquid). Se cere pagina pe care STĂ
   secțiunea: URL-ul coșului (`routes.cart_url`, injectat în DLSettings.routes.cart de layout —
   contează pe magazinele cu prefix de limbă, unde coșul e /ro/cart).

   Dacă totuși re-randarea eșuează (cheie absentă, HTML fără secțiune, rețea căzută), reîncărcăm
   pagina: mai bine un reload decât o pagină care contrazice coșul real.

   Tipar de înregistrare: vezi antetul theme.js — coada DL.plugins e creată aici pentru că acest
   script rulează înaintea lui (theme.js e ultimul din <body>). */
(function (fn) {
  var D = (window.DL = window.DL || {});
  (D.plugins = D.plugins || []).push(fn);
  if (D.init && D._ready) fn(document);
})(function (root) {
  var section = root.querySelector('[data-section-type="main-cart"]');
  if (!section || section.dataset.bound) return;
  section.dataset.bound = '1';

  var reload = function () { window.location.reload(); };

  var render = function () {
    var current = document.querySelector('[data-section-type="main-cart"]');
    if (!current) return;
    var sectionId = current.dataset.sectionId;
    var cartUrl = (window.DLSettings && window.DLSettings.routes && window.DLSettings.routes.cart) || '/cart';
    fetch(cartUrl + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        var next = null;
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          next = tmp.querySelector('[data-section-type="main-cart"]');
        }
        if (!next) return reload();
        current.replaceWith(next);
        // current is now detached: run ITS teardown (below) so the listener this closure
        // is about to re-register on `next` via DL.init doesn't end up duplicated.
        DL.destroy(current);
        DL.init(document);
      })
      .catch(reload);
  };

  document.addEventListener('dl:cart-updated', render);
  // Teardown convention shared with the rest of the theme (see theme.js's own header comment):
  // register the listener's cleanup against THIS node, run by DL.destroy() on shopify:section:unload.
  DL.onDestroy(section, function () { document.removeEventListener('dl:cart-updated', render); });
});
